import Div from "@jumbo/shared/Div";
import { ErrorMessage, Form, Formik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Button, TextField, Typography } from "@mui/material";
import Swal from "sweetalert2";
import { LoadingButton } from "@mui/lab";
import AllApis from "app/Apis/apis";
import { Axios } from "index";
import Heading from "app/pages/Component/Heading";

export default function AddEditGst() {
  const { state, pathname } = useLocation();
  const navigate = useNavigate();
  const [isSubmitting, setSubmitting] = useState(false);
  const [headingName, setHeadingName] = useState(
    pathname.split("/").pop() == "add"
      ? "Add New GST Percentage"
      : "Edit GST Percentage"
  );

  const initialValues = {
    gst_percentage: state?.current_data?.gst_percentage
      ? state?.current_data?.gst_percentage
      : "",
  };

  const validationSchema = yup.object({
    gst_percentage: yup.string().required("GST Percentage is required"),
  });

  const onUserSave = async (values) => {
    let response;
    try {
      setSubmitting(true);
      if (pathname.split("/").pop() === "add") {
        response = await Axios.post(AllApis.gst.add, values);
      } else {
        // Assuming you have a valid 'state' object
        response = await Axios.patch(AllApis.gst.edit(state._id), values);
      }
      if (response?.data?.statusCode) {
        Swal.fire({
          title:
            pathname.split("/").pop() === "add"
              ? "New GST %  Created"
              : "GST % Updated",
          icon: "success",
          timer: 1000,
          showConfirmButton: false,
        });
        navigate("/dashboards/master/gst");
      }
    } catch (error) {
      Swal.fire({
        title: error?.response?.data.message,
        icon: "error",
        timer: 1000,
        showConfirmButton: false,
      });
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(async () => {}, []);

  return (
    <Div sx={{ mt: -4 }}>
      <Heading Name={headingName} />
      <Div>
        <Formik
          validateOnChange={true}
          initialValues={initialValues}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={onUserSave}
        >
          {({ setFieldValue, values, errors, touched }) => (
            <Form noValidate autoComplete="off">
              <Div sx={{ mt: 4 }}>
                <Div
                  sx={{
                    display: "flex",
                    width: "100%",
                    flexWrap: "wrap",
                    columnGap: 5,
                    rowGap: 1,
                  }}
                >
                  <Div sx={{ width: "45%", mt: 2 }}>
                    <Typography variant="h5">GST Percentage (%)</Typography>
                    <TextField
                      name="gst_percentage"
                      size="small"
                      error={
                        !!(touched.gst_percentage && errors.gst_percentage)
                      }
                      value={values?.gst_percentage}
                      sx={{
                        width: "100%",
                        borderColor:
                          values.gst_percentage && errors.gst_percentage
                            ? "red"
                            : "",
                      }}
                      onChange={(e) =>
                        setFieldValue("gst_percentage", e.target.value)
                      }
                    />
                    <ErrorMessage
                      name="gst_percentage"
                      component={"div"}
                      style={{ color: "red" }}
                    ></ErrorMessage>
                  </Div>

                  <Div
                    sx={{
                      width: "93.5%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 3,
                      mt: 3,
                    }}
                  >
                    <Button
                      sx={{ width: "100px" }}
                      variant="outlined"
                      onClick={() => navigate("/dashboards/master/gst")}
                    >
                      Back
                    </Button>

                    <LoadingButton
                      variant="contained"
                      type="submit"
                      sx={{ width: "100px" }}
                      loading={isSubmitting}
                    >
                      Save
                    </LoadingButton>
                  </Div>
                </Div>
              </Div>
            </Form>
          )}
        </Formik>
      </Div>
    </Div>
  );
}
